import { CIcon } from '~/icons/types'

export const ciTrailers: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.248 14.153h-2.325V7.08a.493.493 0 0 0-.985 0v2.648H1.24v-.975a.493.493 0 0 0-.985 0v5.893a.493.493 0 0 0 .493.492H2.2a2.979 2.979 0 0 1 5.048-1.908c.28.273.504.598.66.956a2.981 2.981 0 0 1 5.71.952h9.14v.708a.493.493 0 0 0 .986 0v-1.2a.5.5 0 0 0-.496-.493Z'
    },
    {
      d:
        'M7.2 15.14a2.038 2.038 0 0 0-4.064.23 2.04 2.04 0 0 0 4.079.066.294.294 0 0 1 0-.066v-.066c-.008-.056-.015-.105-.015-.164Zm5.468 0a2.038 2.038 0 0 0-4.064.23 2.04 2.04 0 0 0 4.078 0v-.066l-.014-.164Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'trailers',
  type: 'solid'
}
